import { createBrowserHistory } from "history";

const customHistory = createBrowserHistory();
let previousLocation = null;
let currentLocation = customHistory.location;

customHistory.listen((location, action) => {
	previousLocation = currentLocation.pathname;
	currentLocation = location;
});

export { previousLocation };

export default customHistory;
